import { IProdView } from '@/lib/types/bevmaq.types';
import useTranslation from 'next-translate/useTranslation';
import LinkTranslated from '../Translator/LinkTranslated';

export function BreadCrumbs({ product }: { product: IProdView }) {
  const { t } = useTranslation();
  return (
    <div className='breadcrumbs mb-4 text-xs md:text-sm'>
      <ul className='flex-wrap '>
        <li>
          <LinkTranslated href='/'>{t('common:Home')}</LinkTranslated>
        </li>
        <li>
          <LinkTranslated href='/buy'>{t('common:Machines')}</LinkTranslated>
        </li>
        <li>
          {/* TODO: add link to category */}
          <LinkTranslated
            href={{
              pathname: '/buy/category/[category_slug]',
              query: {
                category_slug: product.category.slug,
              },
            }}
          >
            {product.category.name}
          </LinkTranslated>
        </li>
        <li>{product.model.name}</li>
      </ul>
    </div>
  );
}
